import { useContext, useState } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { CalendarIconNew } from "../../../../assets/icons/icon";
import { RangePicker } from "../../../common";
import styles from "./styles.module.css";
import { Box } from "@mui/material";
import I18n from "../../../../languageConfig";
import { DEFAULT_DATE_FILTERS_EXPORT, DEFAULT_DATE_FILTERS_REPORTS } from "../../../../constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
const BusinessOverviewCard = ({
  title,
  dateConfig,
  total,
  totalSubTitle,
  firstCountLabel,
  secondCountLabel,
  firstCountValue,
  firstCountValueClassName,
  onFirstCountValueClick,
  secondCountValue,
  secondCountValueClassName,
  onSecondCountValueClick,
  handleSeeDetail,
}) => {
  const [i18n] = useContext(LanguageContext);
  const [isDateOpen, setIsDateOpen] = useState(false);

  return (
    <Box className={styles.BusinessOverviewCard}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <ParagraphText className={"fontSize14 fontWeight500 newFontColor"}>
          {i18n[title] || title}
        </ParagraphText>

        <Box className={styles.exportWrap}>
          <UBButton
            id="business_overview_card_btn"
            title={dateConfig.applyBtnText}
            onClick={() => setIsDateOpen(!isDateOpen)}
            spinnerColor={dateConfig.spinnerColor}
            iconComponent={
              dateConfig.loading
                ? null
                : (dateConfig.iconComponent ?? (
                    <CalendarIconNew width="12px" height="12px" />
                  ))
            }
            className={styles.exportButton}
            loading={dateConfig.loading}
          />

          {isDateOpen ? (
            <RangePicker
              onFilterDate={(startDate, endDate) => {
                setIsDateOpen(false);
                dateConfig.onExport(startDate, endDate);
              }}
              onClearBtn={() => dateConfig.onExport("")}
              isOpen={isDateOpen}
              setIsOpen={setIsDateOpen}
              showDirectPicker={true}
              rangeValue={dateConfig?.selectedDate?.start_date && dateConfig?.selectedDate?.end_date ? [dateConfig.selectedDate.start_date, dateConfig.selectedDate.end_date] : []}
              className={styles.rangePickerWrapper}
              dateFilters={DEFAULT_DATE_FILTERS_REPORTS}
              noClearBtn={true}
              minDate={dateConfig?.minDate}
              maxDate={dateConfig?.maxDate}
            />
          ) : null}
        </Box>
      </Box>

      <Box className={`marginTop10 ${styles.labelContainer}`}>
        <ParagraphText
          className={`fontSize20 fontWeight500 newFontColor ${styles.valueText}`}
          title={`Rs. ${total || 0}`}
        >{`Rs. ${total || 0}`}</ParagraphText>

        <ParagraphText
          className={`fontSize14 newLightColor`}
        >
          {" "}
          {i18n[totalSubTitle] || totalSubTitle}{" "}
        </ParagraphText>
      </Box>

      <hr/>

      <Box
        className={styles.listContainer}
      >
        <ParagraphText 
        
        className={"fontSize14 newLightColor fontWeight400"}>
          {" "}
          {i18n[firstCountLabel] || firstCountLabel}{" "}
        </ParagraphText>
        <ParagraphText
        onClick={onFirstCountValueClick}
        title={firstCountValue}
        className={`fontSize14 fontWeight400 newFontColor ${styles.valueText} ${firstCountValueClassName}`}>
          {firstCountValue}
        </ParagraphText>
      </Box>
      <Box
        className={styles.listContainer}
      >
        <ParagraphText className={"fontSize14 newLightColor"}>
          {" "}
          {i18n[secondCountLabel] || secondCountLabel}{" "}
        </ParagraphText>
        <ParagraphText
        onClick={onSecondCountValueClick}
        title={secondCountValue}
        className={`fontSize14 newFontColor fontWeight400 ${styles.valueText} ${secondCountValueClassName}`}>
          {secondCountValue}
        </ParagraphText>
      </Box>
      <ParagraphText
        className={
          `textDecorationUnerline fontSize14 barclayBlueColor cursorPointer fontWeight500 ${styles.seeDetails}`
        }
        onClick={() => {
          triggerLogEvent(analytics, "bo_card_click", { card_type: title });
          handleSeeDetail();
        }}
      >
        {I18n.see_details}
      </ParagraphText>
    </Box>
  );
};

export default BusinessOverviewCard;
